export class Ordenacao{
    name: string;
    value: string;
}